import {AbstractModel} from '../abstract-model';

export class LinkParameters extends AbstractModel {
  pool: string = '';
  affid: string = '';
  subid: string = '';
  tc1: string = '';
  tc2: string = '';
  tc3: string = '';
  tc4: string = '';
  clickid: string = '';
  gclid: string = '';
  fbclid: string = '';
  fbpxid: string = '';
  mspxid: string = '';
  twclid: string = '';
  twpxid: string = '';
  ttclid: string = '';
  ttpxid: string = '';
  source: string = '';
  oid: string | number = '';
  lp: string | number = '';
}
